"use client";

import { sizes } from "@/components/bloks/Asset";
import { Translate } from "@/components/Translate";
import { Skeleton } from "@/components/ui/Skeleton";
import { Link } from "@/i18n/routing";
import type { ProductDetails } from "@/lib/centra";
import Image from "next/image";
import styles from "./VariantSelector.module.css";

type Variant = ProductDetails & {
	selected?: boolean;
};

export interface VariantSelectorProps {
	variants?: Variant[];
	hideHeader?: boolean;
}

export const VariantSelector = ({
	variants,
	hideHeader = false,
}: VariantSelectorProps) => {
	if (!variants) return null;

	const sortedVarians = variants
		.filter((v) => !!v.centraVariant)
		.sort((a, b) => a.centraVariant!.localeCompare(b.centraVariant!));

	const selectedVariantName = variants.find((v) => v.selected)?.variantName;

	return (
		<div className={styles.root}>
			{!hideHeader && selectedVariantName && (
				<span className={styles.label}>
					<Translate>Color</Translate>: {selectedVariantName}
				</span>
			)}
			<div className={styles.variants}>
				{sortedVarians.map((variant, i) => {
					if (!variant) return null;
					return (
						<Link
							href={`/${variant.uri}`}
							key={i}
							className={styles.variant}
							data-selected={variant.selected}
							aria-label={`View details about ${variant.name}`}
						>
							<Image
								fill
								src={variant.media.at(0)?.href || "/fallback-image.jpg"}
								sizes={sizes(10, 10)}
								alt=""
							/>
						</Link>
					);
				})}
			</div>
		</div>
	);
};

export const VariantSelectorSkeleton = ({ size = 4 }: { size?: number }) => {
	return (
		<div className={styles.root}>
			<Skeleton fitContent>
				<span className={styles.label}>Lorem ipsum dolor</span>
			</Skeleton>
			<div className={styles.variants}>
				{Array.from({ length: size }).map((_, index) => (
					<Skeleton fitContent key={index}>
						<div className={styles.variant}>
							<Image fill src={"/fallback-image.jpg"} alt="" />
						</div>
					</Skeleton>
				))}
			</div>
		</div>
	);
};
